/**
 * Quick-view modal: show scrollbar thumb only while scrolling.
 */
(function () {
  if (window.__tmnQuickviewScrollBound) return;
  window.__tmnQuickviewScrollBound = true;

  var hideTimer = null;

  function bindScrollFade(el) {
    if (!el || el.dataset.tmnScrollFade === '1') return;
    el.dataset.tmnScrollFade = '1';

    el.addEventListener(
      'scroll',
      function () {
        el.classList.add('is-scrolling');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          el.classList.remove('is-scrolling');
        }, 700);
      },
      { passive: true }
    );
  }

  function bindOpenModal() {
    var content = document.querySelector('.m-modal.m-open-modal .m-modal--content');
    if (content && content.querySelector('.m-product-quickview')) {
      bindScrollFade(content);
    }
  }

  document.addEventListener('quick-view:loaded', function () {
    requestAnimationFrame(bindOpenModal);
  });

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (
        t &&
        t.classList &&
        t.classList.contains('m-modal--content') &&
        t.querySelector &&
        t.querySelector('.m-product-quickview')
      ) {
        bindScrollFade(t);
      }
    },
    true
  );
})();
